export const findSafePageCut = ({
  paintedRows = [],
  targetRow,
  minRow = 0,
  safetyRows = 4,
}) => {
  const target = Math.max(minRow, Math.min(Number(targetRow) || 0, paintedRows.length - 1));
  for (let row = target; row >= minRow; row -= 1) {
    let blank = true;
    for (let offset = 0; offset < safetyRows; offset += 1) {
      const index = row - offset;
      if (index < minRow) {
        blank = false;
        break;
      }
      if (paintedRows[index]) {
        blank = false;
        break;
      }
    }
    if (blank) return row;
  }
  return Math.max(minRow, target - safetyRows);
};
